import React from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'

const content = [
    { title: 'Parental control', description: 'Greater control over the type of internet content that comes into your home. Helps block inappropriate or harmful websites.' },
    { title: 'Focus-time', description: 'Schedule access to distracting content such as gaming, video streaming or social media with Focus-time.' },
    { title: 'Web security', description: 'Protects you from malware such as viruses, crypto jacking, ransomware, and banking-trojans.' },
    { title: 'Anti-phishing', description: 'Helps block sites that seek to steal your personal data and identity.' },
    { title: 'Anti-bot', description: 'Using up-to-date threat intelligence, Home Secure can look out for bot infected sites and aim to block them at the source.' },
    { title: 'Safe search', description: 'With one switch you can enable Safe Search on Google, YouTube and more on all devices on your home network.' }
]

const HomeSecurePlan = (props) => {
    return (
        <div>
            <div className='text-center mb-4'>
                <div className='row'>
                    <div className='col-12 col-lg-8 offset-lg-2'>
                        <h2 className='m-0 mb-2' dangerouslySetInnerHTML={{ __html: globals.noWidows(props.heading) }} />
                    </div>
                    <div className='col-12 col-lg-10 offset-lg-1'>
                        <p className='m-0 lh' dangerouslySetInnerHTML={{ __html: globals.noWidows(props.subHeading) }} />
                    </div>
                </div>
            </div>

            <div className='home-secure-plan text-left'>
                <div className='row'>
                    <div className='headings col-12 col-lg-8'>
                        {content.map((item, key) => {
                            return (
                                <div key={key} className='row mb-3'>
                                    <div className='col-12 col-lg-3 mb-1 mb-lg-0'><p className='bold lh m-0'>{item.title}</p></div>
                                    <div className='col-12 col-lg-9'><p className='lh m-0' dangerouslySetInnerHTML={{ __html: globals.noWidows(item.description) }} /></div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='images col-12 col-lg-4 d-flex align-items-center justify-content-center'>
                        <img src='/images/home-secure/icon-home-secure.svg' className='d-lg-inline-block mb-3' />
                    </div>
                </div>
            </div>
        </div>
    )
}

HomeSecurePlan.propTypes = {
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired
}

HomeSecurePlan.defaultProps = {
    heading: 'Test'
}

export default HomeSecurePlan



// WEBPACK FOOTER //
// ./resources/js/components/HomeSecurePlan.js